import React from 'react'
import { getLocale, tr } from 'i18n'
import './RequestCount.scss'

export default function RequestCount({ count }) {
  const value = count === null ? '—' : new Intl.NumberFormat(getLocale()).format(count)
  return <strong className={`request-count${count === 0 ? ' request-count--empty' : ''}`}
    aria-hidden="true" title={`${tr('На рассмотрении')}: ${value}`}>{value}</strong>
}
